import {
  ButtonBase,
  ButtonBaseProps,
  IconButton,
  Plus,
  Text,
} from '@sparemin/blockhead';
import dayjs from 'dayjs';
import React from 'react';
import { Calendar } from 'components/icons';
import { useSocialShareModal } from '../SocialShareModalContext';
import useIsBlockingActionInProgress from '../useIsBlockingActionInProgress';
import { socialShareModalFooterBlock as block } from '../utils';

export type ScheduledDatePreviewProps = Pick<ButtonBaseProps, 'onPress'>;

const ScheduledDatePreview: React.FC<ScheduledDatePreviewProps> = ({
  onPress,
}) => {
  const { scheduledDate, onScheduledDateChange } = useSocialShareModal();
  const isBlockingActionInProgress = useIsBlockingActionInProgress();

  return (
    <div className={block('scheduled-date-preview-container')}>
      <ButtonBase
        isDisabled={isBlockingActionInProgress}
        className={block('scheduled-date-preview-button')}
        onPress={onPress}
      >
        <Calendar />

        <Text
          variant="label"
          letterSpacing="1.2px"
          textTransform="uppercase"
          weight={700}
        >
          {scheduledDate
            ? dayjs(scheduledDate).format('D MMMM YYYY hh:mm A [GMT]Z')
            : ''}
        </Text>
      </ButtonBase>

      <IconButton
        isDisabled={isBlockingActionInProgress}
        className={block('remove-scheduled-date-button')}
        onPress={() => onScheduledDateChange(undefined)}
      >
        <Plus />
      </IconButton>
    </div>
  );
};

export default ScheduledDatePreview;
